import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { ToastController } from "@ionic/angular";
import { ProgressSpinnerComponent } from "src/app/progress-spinner/progress-spinner.component";
import { AuditTrailService } from "../audit-trail.service";

export interface PeriodicElement {
  // qsQuestion: string;
  // qs_ans_status: number;
  // qs_ans: number;
  qsCode: string;
  // symbol: string;
}

@Component({
  selector: "app-registration-report",
  templateUrl: "./registration-report.component.html",
  styleUrls: ["./registration-report.component.scss"],
})
export class RegistrationReportComponent implements OnInit {
  documents: any[] = [];
  downloadEsignDisabled: boolean = true;
  areQuestionsNotAnswered: boolean = false;
  manualRejectedQuestions: any[] = [];
  profileDetails: any[] = [];
  verifiedStatus: any[] = [];
  applyNowBtnDisabled = true;
  isEsignDisabled = true;
  dataSource = new MatTableDataSource();
  // displayedColumns: string[] = ["qs_ans_status", "qsQuestion", "qs_ans"];
  displayedColumns: any[] = ["qsCode"];
  constructor(
    public toastController: ToastController,
    private dialog: MatDialog,
    private auditTrailService: AuditTrailService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.getDocuments();
  }

  async getDocuments() {
    this.manualRejectedQuestions = [];
    this.documents = [];
    this.verifiedStatus = [];
    const progressSpinnerDialog = await this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
    await this.auditTrailService.getProfileDetailsReport("266").subscribe((response: any) => {
      progressSpinnerDialog.close();
      console.log(response);

      if (response != null && !response.error) {
        this.profileDetails = response.pop();
        if (response.length > 0) {
          localStorage.setItem("editRecords", JSON.stringify(response));
          let employeeFlag = false;

          for (let i = 0; i < response.length; i++) {
            if (response[i]["qsCode"] == "Q_CASTE" && response[i]["qs_ans"] == "OPEN") {
              response[i + 1]["qs_ans_status"] = "Not Applicable";
            }

            if (response[i]["qsCode"] == "Q_DOMICILE" && response[i]["qs_ans_status"] == "Not-Verified") {
              response[i]["qs_ans_status"] = "Verification in Progress";
            }

            if (response[i]["qsCode"] == "Q_ITR" && response[i]["qs_ans_status"] == "Not-Verified") {
              response[i]["qs_ans_status"] = "Verification in Progress";
            } else if (response[i]["qsCode"] == "Q_ITR_SPOUSE" && response[i]["qs_ans_status"] == "Not-Verified") {
              response[i]["qs_ans_status"] = "Verification in Progress";
            }

            if (response[i]["qsCode"] == "Q_MARITAL" && response[i]["qs_ans"] != "Married") {
              // i = 6
              if (response[i + 3]["qsCode"] == "Q_WORK_STATUS" && response[i + 3]["qs_ans"] == "None") {
                response[i + 1]["qs_ans_status"] = "Not Applicable"; // i = 7
                response[i + 2]["qs_ans_status"] = "Not Applicable"; // i = 8
                response[i + 4]["qs_ans_status"] = "Not Applicable"; // i = 8
                response[i + 5]["qs_ans_status"] = "Not Applicable"; // i = 11
                response[i + 6]["qs_ans_status"] = "Not Applicable"; // i = 12
              } else {
                response[i + 1]["qs_ans_status"] = "Not Applicable"; // i = 7
                response[i + 2]["qs_ans_status"] = "Not Applicable"; // i = 8
                response[i + 5]["qs_ans_status"] = "Not Applicable"; // i = 11
                response[i + 6]["qs_ans_status"] = "Not Applicable"; // i = 12
              }
            } else if (response[i]["qsCode"] == "Q_MARITAL" && response[i]["qs_ans"] == "Married") {
              // i= 6
              if (response[i + 3]["qsCode"] == "Q_WORK_STATUS" && response[i + 3]["qs_ans_status"] != "Not Answered") {
                // i = 9
                if (response[i + 3]["qs_ans"] == "Both") {
                  if (
                    response[i + 4]["qs_ans_status"] == "Verified" ||
                    response[i + 4]["qs_ans_status"] == "Rejected" ||
                    response[i + 5]["qs_ans_status"] == "Verified" ||
                    response[i + 5]["qs_ans_status"] == "Rejected"
                  ) {
                    response[i + 6]["qs_ans_status"] = "Not Applicable";
                  } else if (
                    response[i + 6]["qs_ans_status"] == "Verified" ||
                    response[i + 6]["qs_ans_status"] == "Rejected" ||
                    response[i + 6]["qs_ans_status"] == "Not-Verified"
                  ) {
                    response[i + 4]["qs_ans_status"] = "Not Applicable";
                    response[i + 5]["qs_ans_status"] = "Not Applicable";
                  }
                } else if (response[i + 3]["qs_ans"] == "Self") {
                  // i = 9
                  response[i + 5]["qs_ans_status"] = "Not Applicable"; // i= 11
                  response[i + 6]["qs_ans_status"] = "Not Applicable"; // i = 12
                } else if (response[i + 3]["qs_ans"] == "Spouse") {
                  // i = 9
                  response[i + 6]["qs_ans_status"] = "Not Applicable";
                  response[i + 4]["qs_ans_status"] = "Not Applicable";
                } else if (response[i + 3]["qs_ans"] == "None") {
                  response[i + 5]["qs_ans_status"] = "Not Applicable";
                  response[i + 6]["qs_ans_status"] = "Not Applicable";
                  response[i + 4]["qs_ans_status"] = "Not Applicable"; // i = 10
                }
              }
            }

            if (employeeFlag == false) {
              if (response[i + 2] != undefined) {
                if (
                  response[i]["qsCode"] == "Q_CENTRAL" &&
                  (response[i]["qs_ans_status"] == "Uploaded" ||
                    response[i]["qs_ans_status"] == "Not-Verified" ||
                    response[i]["qs_ans_status"] == "Verified")
                ) {
                  response[i + 1]["qs_ans_status"] = "Not Applicable";
                  response[i + 2]["qs_ans_status"] = "Not Applicable";
                  response[6]["qs_ans_status"] = "Not Applicable";
                  employeeFlag = true;
                } else if (
                  response[i + 1]["qsCode"] == "Q_STATE" &&
                  (response[i + 1]["qs_ans_status"] == "Uploaded" ||
                    response[i + 1]["qs_ans_status"] == "Not-Verified" ||
                    response[i + 1]["qs_ans_status"] == "Verified")
                ) {
                  response[i]["qs_ans_status"] = "Not Applicable";
                  response[i + 2]["qs_ans_status"] = "Not Applicable";
                  employeeFlag = true;
                } else if (
                  response[i + 2]["qsCode"] == "Q_MHADA" &&
                  (response[i + 2]["qs_ans_status"] == "Verified" || response[i + 2]["qs_ans_status"] == "Rejected")
                ) {
                  response[i]["qs_ans_status"] = "Not Applicable";
                  response[i + 1]["qs_ans_status"] = "Not Applicable";
                  employeeFlag = true;
                }
              }
            }

            if (
              (response[i]["qs_ans"] == "No" && response[i]["qs_ans_status"] == "Answered") ||
              (response[i]["qs_ans"] == "None" && response[i]["qs_ans_status"] == "Answered") ||
              (response[i]["qs_ans"] == "None of the above" && response[i]["qs_ans_status"] == "Answered")
            ) {
              if (response[i]["qsCode"] == "Q_CAST_VALID") {
                response[i]["qs_ans_status"] = "Allowed with Condition";
              } else {
                response[i]["qs_ans_status"] = "Not Applicable";
                response[i]["qs_ans"] = "";
              }
            } else if (response[i]["qs_ans_status"] == "Not-Verified") {
              response[i]["qs_ans_status"] = "Verification in Progress";
            }
            this.documents.push(response[i]);
          }

          for (let i = 0; i < this.documents.length; i++) {
            // if (this.documents[i]["qs_ans_status"] == "Rejected-Manual") {
            if (
              this.documents[i]["qs_ans_status"] != null &&
              this.documents[i]["qs_ans_status"].toLowerCase().includes("rejected")
            ) {
              this.manualRejectedQuestions.push(this.documents[i]);
              this.applyNowBtnDisabled = true;
              this.downloadEsignDisabled = true;
              this.isEsignDisabled = true;
              this.areQuestionsNotAnswered = true;
            } else if (
              this.documents[i]["qs_ans_status"] == null ||
              this.documents[i]["qs_ans_status"].startsWith("Rejected") ||
              this.documents[i]["qs_ans_status"] == "Not Answered" ||
              this.documents[i]["qs_ans_status"] == "Pending for Moderator Check" ||
              this.documents[i]["qs_ans_status"] == "Verification in Progress"
            ) {
              this.applyNowBtnDisabled = true;
              this.downloadEsignDisabled = true;
              this.isEsignDisabled = true;
              this.areQuestionsNotAnswered = true;
            }
          }

          if (this.manualRejectedQuestions.length > 0) {
            console.log(this.manualRejectedQuestions);
          }
          setTimeout(() => {
            console.log(this.documents);
            if (this.profileDetails[0]["affidavitStatus"] == "" && this.areQuestionsNotAnswered == false) {
              this.applyNowBtnDisabled = true;
              this.downloadEsignDisabled = true;
              this.isEsignDisabled = false;
              localStorage.removeItem("eSign");
            } else if (
              this.profileDetails[0]["affidavitStatus"].toLowerCase() == "pending" &&
              this.areQuestionsNotAnswered == false
            ) {
              if (localStorage.getItem("eSign") == "true") {
                // this.getSignedPdf();
              } else {
                localStorage.removeItem("eSign");
                this.applyNowBtnDisabled = true;
                this.downloadEsignDisabled = true;
                this.isEsignDisabled = false;
              }
            } else if (
              this.profileDetails[0]["affidavitStatus"].toLowerCase() == "verified" &&
              this.areQuestionsNotAnswered == false
            ) {
              this.applyNowBtnDisabled = false;
              this.downloadEsignDisabled = false;
              this.isEsignDisabled = true;
            }
          }, 1000);

          this.dataSourceData = [];

          for (let i = 0; i < this.documents.length; i++) {
            console.log(this.documents[i]["qsQuestion"]["en"]);
            this.dataSourceData.push({
              // qsCode: this.documents[i]["qsCode"],
              qsProfileDescription: this.documents[i]["qsProfileDescription"]["en"],
              qs_ans: this.documents[i]["qs_ans"],
              qs_ans_status: this.documents[i]["qs_ans_status"],
            });
          }
          this.arrayOfKeys = Object.keys(this.dataSourceData[0]);
          this.dataSource.data = this.dataSourceData;
        } else {
          this.warningToast(response.error);
        }
      } else {
        this.errorToast(response);
      }
    });
  }

  arrayOfKeys: any[] = [];
  dataSourceData: any[] = [];
  async warningToast(message: any) {
    await this._snackBar.open(message, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "warning-toast",
      duration: 5000,
    });
  }

  async successToast(message: any) {
    await this._snackBar.open(message, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 5000,
    });
  }

  async errorToast(error: any) {
    await this._snackBar.open(
      "There was network related or instance related error understanding the request. Please try doing it again.",
      "Close",
      {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: 5000,
      }
    );
  }
}
